<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Notification</h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <div style="width: 100%" class="mt-3">
        <CCol sm="12">
          <span @click="GoToPageNotification()">
            <br />
            <img
              src="../assets/img/add_new.png"
              width="40px"
              class="float-right mr-2 mt-2"
            />
          </span>

          <span class="mt-5 mb-5"> </span>
          <br /><br />
          <br /><br />
          <br /><br />
          <br /><br />
        </CCol>
      </div>
    </div>
    <CCard class="custom-card h-100">
      <CCol sm="12" class="justify-content-center m-0">
        <CContainer>
          <CCol sm="12" lg="12" class="custom-margin m-0 p-0">
            <h5 class="text-left mt-2 d-flex d-sm-none text-black bold">
              Parent Messages <br />
            </h5>
            <div class="mt-2">
              <img
                src="../assets/img/iconInfo.png"
                width="20px"
                height="20px"
                class="mr-2"
              />
              This is a job published by parents to all qualified tutors. Once
              they select one of the tutors and tutors who accept the job, the
              other will be dropped. Once the parents receive your application,
              you need to respond to receive the application within 24 hours.
            </div>
            <!-- <CCol sm="12" lg="12" class="mt-2">
              <CRow>
                <span sm="4" lg="4" @click="RefreshData()"
                  ><CCard style="display:inline-block" class="p-1"
                    ><img
                      style="width:25px"
                      src="../assets/img/menu.png"
                      class="mr-1"
                    />
                    <strong>All</strong></CCard
                  >
                </span>
                <span sm="4" lg="4" @click="ApplyOpenJob()" class="ml-2"
                  ><CCard style="display:inline-block" class="p-1"
                    ><img
                      style="width:25px"
                      src="../assets/img/offer.png"
                      class="mr-1"
                    />
                    <strong>Open Job</strong></CCard
                  ></span
                >
                <span sm="4" lg="4" @click="ApplyConfirmJob()" class="ml-2"
                  ><CCard style="display:inline-block" class="p-1"
                    ><img
                      style="width:25px"
                      src="../assets/img/confirm.png"
                      class="mr-1"
                    /><strong>Job confirmed</strong></CCard
                  ></span
                >
              </CRow>
            </CCol> -->

            <CCol sm="12" lg="12" class="mt-4" style="display: flex;">
              <span
                sm="4"
                lg="4"
                @click="ApplyOpenJob()"
                class="ml-2"
                style="flex:1;"
                ><CCard
                  style="border: 2px solid #009688; border-radius:10px;"
                  class="p-2"
                >
                  <CCol>
                    <img
                      style="width:25px"
                      src="../assets/img/offer.png"
                      class="mr-2"
                    />
                    <strong>Open Job</strong>
                  </CCol>
                </CCard></span
              >
              <span
                sm="4"
                lg="4"
                @click="ApplyConfirmJob()"
                class="ml-2"
                style="flex:1;"
                ><CCard
                  style="border: 2px solid #009688; border-radius:10px;"
                  class="p-2"
                >
                  <CCol>
                    <img
                      style="width:25px"
                      src="../assets/img/confirm.png"
                      class="mr-2"
                    /><strong>Job confirmed</strong>
                  </CCol>
                </CCard></span
              >
            </CCol>

            <CCard v-if="!FilteredNotification.length">
              <div class="mt-5 text-center mb-5">
                <img src="../assets/img/nodata.png" width="120px" />
                <br />
                No notification yet
              </div>
            </CCard>
            <CCard
              v-for="item in FindTutorDt"
              v-bind:key="item.Id"
              class="p-2 mt-2"
              style="border: 2px solid #99A3A4; border-radius:10px;"
            >
              <CCol>
                <CRow sm="10" lg="10" class=" d-flex">
                  <CCol sm="12" lg="12">
                    <CRow>
                      <CCol sm="12" lg="12">
                        <img
                          width="30"
                          height="30"
                          src="../assets/img/joboffer.jpg"
                          class="mb-2"
                          style="border: 1px solid #99A3A4; border-radius:10px;"
                        />
                        <strong class="ml-2 mb-2"
                          >Job ({{ item.FindTutorId }})</strong
                        ><strong class="float-right">
                          {{ item.CreatedTime }}</strong
                        >
                        <br />
                        <label>{{ item.Description }}</label>
                         <br />
                        <strong> {{ item.StudentName }} </strong>
                        <br />
                        - subject <strong> {{ item.SubjectName }} </strong>
                        <br />
                        - grade <strong> {{ item.GradeName }} </strong> <br />
                        <label v-if="item.TypeOfGroup === false">
                            - type
                          <strong>
                            One-to-One</strong
                          ></label>
                        <label v-else
                          > - type
                          <strong color="warning" class="fontlist">
                            Group Of Two</strong
                          ></label>
                        <br />
                        <label v-if="item.Status === false"
                          >Job Status
                          <CBadge color="success"> Open</CBadge></label
                        >
                        <label v-else
                          >Job Status
                          <CBadge color="danger"> Closed</CBadge></label
                        >
                        <br />
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>

              <!-- <CCol sm="12" lg="12" class="m-2">
                <CRow>
                  <article>
                    <div>
                      <CCol sm="12" lg="12">
                        <img
                          width="30"
                          height="30"
                          src="../assets/img/joboffer.jpg"
                          style="border: 1px solid #99A3A4; border-radius:10px;"
                        />
                        <strong class="ml-2 mb-2"
                          >Job ({{ item.FindTutorId }})</strong
                        ><strong class="float-right">
                          {{ item.CreatedTime }}</strong
                        >
                      </CCol>

                     <br />
                      <label>{{ item.Description }}</label>
                      <br />
                      - subject <strong> {{ item.SubjectName }} </strong>
                      <br />
                      - grade <strong> {{ item.GradeName }} </strong> <br />
                      <label v-if="item.Status === false"
                        >Job Status
                        <CBadge color="success"> Open</CBadge></label
                      >
                      <label v-else
                        >Job Status
                        <CBadge color="danger"> Closed</CBadge></label
                      >
                      <br />
                    </div>
                  </article>
                </CRow>
              </CCol> -->
            </CCard>
            <CCard
              v-for="(item, index) in FilteredNotification"
              v-bind:key="item.Id"
              class="mt-2 p-2 d-none d-sm-flex"
            >
              <CCol sm="12" lg="12" v-if="item.Type == 3">
                <CRow @click="GoToPageNotificationResponse(index)">
                  <CCol sm="1" lg="1">
                    <div class="p-2">
                      <img
                        width="50"
                        height="50"
                        src="../assets/img/acceptjob.jpg"
                      />
                    </div>
                  </CCol>
                  <CCol class="float-right">
                    <CRow>
                      <CCol sm="9" lg="9">
                        <strong>Job ({{ item.FindTutorId }})</strong>
                        <br />
                        Class
                        <CBadge color="primary">{{ item.SubjectName }}</CBadge>
                        <br />
                        <label>{{ item.Description }}</label>
                        <br />
                      </CCol>
                      <CCol sm="3" lg="3">
                        <strong class="mt-5">
                          <i>{{ item.CreatedTime }}</i></strong
                        >
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>

              <CCol sm="12" lg="12" v-else>
                <CRow v-if="item.Status === true">
                  <CCol sm="1" lg="1">
                    <div class="p-2">
                      <img
                        width="50"
                        height="50"
                        src="../assets/img/joboffer.jpg"
                      />
                    </div>
                  </CCol>
                  <CCol class="float-right">
                    <CRow>
                      <CCol sm="9" lg="9">
                        <strong>Job ({{ item.FindTutorId }})</strong>
                        <br />
                        Class
                        <CBadge color="primary">{{ item.SubjectName }}</CBadge>
                        <br />
                        <label>{{ item.Description }}</label>

                        <br />
                        <label v-if="item.Status === false"
                          >Job Status
                          <CBadge color="success"> Open</CBadge></label
                        >
                        <label v-else
                          >Job Status
                          <CBadge color="danger"> Closed</CBadge></label
                        >
                        <br />
                      </CCol>
                      <CCol sm="3" lg="3">
                        <strong class="mt-5">
                          <i>{{ item.CreatedTime }}</i></strong
                        >
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>

                <CRow v-else @click="GoToPageResponse(index)">
                  <CCol sm="1" lg="1">
                    <div class="p-2">
                      <img
                        width="50"
                        height="50"
                        src="../assets/img/joboffer.jpg"
                      />
                    </div>
                  </CCol>
                  <CCol class="float-right">
                    <CRow>
                      <CCol sm="9" lg="9">
                        <strong>Job ({{ item.FindTutorId }})</strong>
                        <br />
                        Class
                        <CBadge color="primary">{{ item.SubjectName }}</CBadge>
                        <br />
                        <label>{{ item.Description }}</label>

                        <br />
                        <label v-if="item.Status === false"
                          >Job Status
                          <CBadge color="success"> Open</CBadge></label
                        >
                        <label v-else
                          >Job Status
                          <CBadge color="danger"> Closed</CBadge></label
                        >
                        <br />
                      </CCol>
                      <CCol sm="3" lg="3">
                        <strong class="mt-5">
                          <i>{{ item.CreatedTime }}</i></strong
                        >
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CCard>
          </CCol>
        </CContainer>
      </CCol>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
export default {
  name: "Login",
  data() {
    return {
      backgroundBanner,
      profiles: [],
      notify: [],
      SearchQuery: "A student offer tutor job for you",
      SearchQueryTutor: "I accept you as Tutor",
      FilteredNotification: [],
      FindTutorDt: [],
      check: ""
    };
  },
  async mounted() {
    await this.GetNotificationTeacher();
    await this.GetFindTutorDetails();
    await this.GetConfirmationSession();
    await this.GetConfirmationTime();
    await this.RefreshData();
    await this.GetCheckingJob();
  },
  methods: {
    async RefreshData() {
      this.GetNotificationTeacher();
    },
    async GetNotificationTeacher() {
      this.$API
        .get(
          this.$NotificationTeacher + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.profiles = response.data;
            this.FilteredNotification = this.profiles;
            this.GetCheckingJob(this.profiles.FindTutorId);
          }
        });
    },
    async GetFindTutorDetails() {
      this.$API
        .get(
          this.$FindtutorFullDetails + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.FindTutorDt = response.data;
            this.profiles = response.data;
          }
        });
    },
    OpenChecking(index) {
      console.log("ma");

      this.findTutorId = this.profiles[index].FindTutorId;
      this.GetCheckingJob(this.findTutorId);

      console.log("t" + this.findTutorId);
    },
    async GetCheckingJob(findTutorId) {
      this.$API
        .get(this.$CheckStatusJob + "?tutorId=" + this.findTutorId, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.check = response.data;
          }
        });
    },
    GoToPageConfirmClass(index) {
      this.$router.push(
        "/ConfirmationClass?notiId=" + this.profiles[index].NotiId
      );
    },
    GoToPageNotificationResponse(index) {
      this.$router.push(
        "/StudentSchedule?notiId=" + this.profiles[index].NotiId
      );
    },
    GoToPageResponse(index) {
      this.$router.push(
        "/ConfirmationClass?notiId=" + this.profiles[index].NotiId
      );
    },
    ApplyOpenJob: function() {
      var arr = this.profiles;
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, function(o) {
          return o.Status == false;
        });

        this.FindTutorDt = result;
      }
    },

    ApplyConfirmJob: function() {
      var arr = _.orderBy(this.profiles, ["Description"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        // const result = _.filter(arr, ({ Description }) =>
        //   _.some([
        //     _.includes(!Description || Description.toLowerCase(), [
        //       this.SearchQueryTutor.toLowerCase("")
        //     ])
        //   ])
        // );
        const result = _.filter(arr, function(o) {
          return o.Status == true;
        });
        this.FindTutorDt = result;
      }
    }
  }
};
</script>
